import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { TipoUsuario } from 'src/app/shared/enums/tipoUsuario';

@Component({
  selector: 'app-configuraciones-index',
  templateUrl: './configuraciones-index.component.html',
  styleUrls: ['./configuraciones-index.component.scss']
})
export class ConfiguracionesIndexComponent implements OnInit {

  TipoUsuario = TipoUsuario;
  
  constructor(
    private authService: AuthService
  ) { }

  ngOnInit(): void {
  }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }

}
